import $ from 'jquery'
import async from 'async'
import util from 'util'
import _ from 'lodash'

let _p = window.xwCommon,
	_this = {
		userCheck(){
			let u = _p.getApiUrl("staff/currentQuery"), func = (callback,reject) => {
				$.get(u,(json) => {
					let status = parseInt(json.status);
					// console.log(status)
					// console.log(json)
					switch(status){
						case 200:
							// 登录成功
							callback(json.data)
							break;
						case 1001:
							callback(false)
							/*
		  					vm.login = false
		  					vm.fullscreenLoading = false
		  					*/
		  					break;
		  				case 1000:
		  					reject(new Error("您暂时没有权限使用本系统，请联系管理员！"))
		  					break;
		  				default:
		  					reject(json)
		  					break;
					}
					//console.log(json);
				});
			}
			return new Promise(func)
		},
		getUserInfo(staff_id){
			let u = _p.getApiUrl("staff/query"), func = (callback,reject) => {
				$.get(u,{staff_id},(json) => {
					let status = parseInt(json.status);
					switch(status){
						case 200:
							callback(json.data);
							break;
						default:
							reject(json);
							break;
					}
					//console.log(json);
				})
			}
			return new Promise(func)
		},
		getVerifyImg(){
			return _p.getApiUrl("login/verifyCode",{"_t":$.now()})
		},
		userSignIn(data,self){
			let u = _p.getApiUrl("login/in"), func = (callback,reject) => {

				let md5 = require('md5');
				data.password = md5(data.password);
				$.post(u,data,(json) => {
					// console.log(json)
					let status = parseInt(json.status)
					switch(status) {
						case 200:
							callback(json);
							self.isLoginBack==true?localStorage.companyName = "HaoChengDa":localStorage.removeItem("companyName");
							break;
						default:
							reject(json)
							break;
					}
				})
			}

			return new Promise(func)
		},
		userSignOut(){
			let u = _p.getApiUrl("login/out"), func = (callback,reject) => {
				$.get(u,(json) => {
					let status = parseInt(json.status);
					switch(status){
						case 200:
						    // _p.Storage('outOrder',true)
							callback(true)
							break;
						default:
							reject(json)
							break;
					}
					//console.log(json);
				});
			}
			return new Promise(func)
		}
	}
export default _this


// WEBPACK FOOTER //
// ./src/lib/common/user.js